module.exports = __webpack_public_path__ + "static/media/finance-loan-repayment.cc2ed879.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/finance-loan-repayment.mp4
// module id = 2580
// module chunks = 0